import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { KioskStorage } from "../kiosk/component/styled/storage";
import { Container } from "../kiosk/component/styled/common";

import KioskHeader from "../kiosk/component/common/kioskHeader";
import KioskFooter from "../kiosk/component/common/kioskFooter";

import ViewType from "../kiosk/component/kioskStorage/viewType";
import TabMenu from "../kiosk/component/kioskStorage/tabMenu";

import ViewAll from "./component/kioskStorage/viewAll";
import ViewDetails from "./component/kioskStorage/viewDetails";
import UserInfoModal from "./component/kioskStorage/modal/userInfoModal";
import UserInfoForm from "./component/kioskStorage/modal/userInfoForm";
import CustResvModal from "./component/kioskStorage/modal/custResvModal";
import StoreSettings from "./component/kioskStorage/modal/storeSettings";

import { printLabel, storageType } from "../kiosk/component/function/kiosk";
import { useRegex } from "../../../hooks/useRegex";
import { useDisableScroll } from "../../../hooks/useDisableScroll";
import { checkKioskCond } from "../dashboard/component/function/dashboard";

const BbdabangStorage = () => {
  useDisableScroll();

  const navigate = useNavigate();

  const [type, setType] = useState(0);
  const [active, setActive] = useState(0);
  const [selected, setSelected] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [origin, setOrigin] = useState([]);
  const [modalType, setModalType] = useState("");

  const { TelFormat } = useRegex();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }
  }, []);

  useEffect(() => {
    getEnableStorage();
  }, [active]);

  useEffect(() => {
    setData(makeStorage(origin));
  }, [origin]);

  const getEnableStorage = async () => {
    const url = "/api/enable-storage";
    const body = { type: active, point: "baseball" };

    const res = await axios.post(url, body);
    console.log(res);
    if (res.status === 200) {
      setOrigin(res.data);
    }
  };
  const makeStorage = (specificData) => {
    const dataLength = 200;
    const config = {
      0: { baseIndex: 1 },
      1: { baseIndex: 501 },
      2: { baseIndex: 2001 },
    };

    const { baseIndex } = config[active] || { baseIndex: 1 };

    const specificDataMap = specificData.reduce((acc, item) => {
      acc[item.storageId] = item;
      return acc;
    }, {});

    return Array.from({ length: dataLength }, (_, idx) => {
      const index = baseIndex + idx;
      let status = "open";

      return {
        ...specificDataMap[index],
        index,
        status,
      };
    });
  };

  const handleClickStorage = (type, item = null) => {
    if (item) {
      setSelected({ ...item, quantity: calcItemCount(item) });
    }
    setModalType(type);
    setOpenModal(true);
  };

  const handleExitModal = async (flag = false) => {
    if (flag) {
      await getEnableStorage();
    }
    setSelected(null);
    setModalType("");
    setOpenModal(false);
  };

  const calcItemCount = (item) => {
    return data.filter((user) => user.mberNm === item.mberNm && user.tel === item.tel).length || 0;
  };

  const getModalContent = () => {
    switch (modalType) {
      case "userInfoForm":
        return (
          <UserInfoForm
            handleExitModal={handleExitModal}
            active={active}
            getPrintElement={getPrintElement}
          />
        );
      case "custResv":
        return (
          <CustResvModal handleExitModal={handleExitModal} getPrintElement={getPrintElement} />
        );
      case "userInfo":
        return <UserInfoModal item={selected} handleExitModal={handleExitModal} />;
      case "storeSettings":
        return <StoreSettings handleExitModal={handleExitModal} />;
      default:
        return null;
    }
  };

  const maskMiddle = (formatted) => {
    return formatted.replace(/(\d{3})-(\d)(\d{3})-(\d{4})/, "$1-$2***-$4");
  };

  // WebPrint SDK 출력
  const getPrintElement = async (items) => {
    for (const item of items) {
      const result = {
        mberNm: item.mberNm,
        storageId: item.storageId,
        type: storageType[item.type].label,
        tel: maskMiddle(TelFormat(item.tel)),
        reserveId: item.reserveId,
        reservationTime: item.reservationStartTime,
      };

      try {
        await printLabel(result);
      } catch (err) {
        toast.error("직원용 라벨 출력 중 에러 발생");
        console.error("sdk printer", err);
        return;
      }
    }

    const customerData = {
      mberNm: items[0].mberNm,
      reserveId: items[0].reserveId,
      reservationTime: items[0].reservationStartTime,
      type: items.reduce((acc, item) => {
        acc[item.type] = acc[item.type] || [];
        acc[item.type].push(item.storageId);
        return acc;
      }, {}),
    };

    try {
      await new Promise((res) => setTimeout(res, 500));
      await printLabel(customerData, true);
    } catch (err) {
      toast.error("고객용 라벨 출력 중 에러 발생");
      console.error("sdk printer", err);
    }
  };

  return (
    <Container>
      <KioskStorage>
        <KioskHeader title={"보관"} handleClickStorage={handleClickStorage} />
        <TabMenu active={active} setActive={setActive} point="baseball" />
        <ViewType
          type={type}
          setType={setType}
          active={active}
          handleClickStorage={handleClickStorage}
          point="baseball"
        />
        {type ? (
          <ViewDetails data={data} handleClickStorage={handleClickStorage} active={active} />
        ) : (
          <ViewAll data={data} handleClickStorage={handleClickStorage} active={active} />
        )}
        <KioskFooter />
        {openModal && getModalContent()}
      </KioskStorage>
    </Container>
  );
};

export default BbdabangStorage;
